import React, { useState } from 'react'
import PropTypes from 'prop-types'
import BookedSlotModal from './BookedSlotModal'
import Menu from 'components/Modules/Slots/TeacherSchedule/components/BookedSlots/Menu'
import Tooltip from 'components/Modules/Slots/components/Tooltip/Tooltip'
import { classNames as cn } from 'helpers'
import { calcTimeWithTimeZoneShift } from 'components/Modules/Slots/utils'
import LocalStorage from 'services/LocalStorage'
import styles from 'components/Modules/Slots/TeacherSchedule/components/BookedSlots/BookedSlots.module.scss'
import slotsAdvancedTeachersHistoryStore from 'Stores/slotsAdvancedTeachersHistoryStore'
import { observer } from 'mobx-react'

function BookedSlot({
  id,
  start_at,
  finish_at,
  color,
  is_client,
  is_deleted,
  is_accessible,
  is_online,
  is_school,
  type_name,
  slot_type_id,
  is_comment,
  zoom_url,
  group_clients,
  comment,
  onClick,
  isMenuShown,
  slot_date,
  employee_id,
  slot_id,
  types,
}) {
  const timeZone = LocalStorage.get('ud')?.user_data?.profile?.time_zone || 0
  const { updateSlot, selectedLocation } = slotsAdvancedTeachersHistoryStore
  const [isModalShown, setIsModalShown] = useState(false)
  const [isTooltipShown, setIsTooltipShown] = useState(false)
  const [modalType, setModalType] = useState(null)
  const currentColor =
    (is_deleted && '#ffdae7') || (is_client && '#b1f5cf') || color

  const handleMouseEnter = () => {
    if (isMenuShown) {
      return
    }
    setIsTooltipShown(true)
  }

  const handleSlotClick = () => {
    setIsTooltipShown(false)
    onClick(id)
  }

  const handleMenuClick = (type) => {
    onClick(id)

    if (!type) {
      return
    }
    if (type === 'restore') {
      updateSlot({
        id,
        is_active: true,
        employee_id,
        slot: slot_id,
        slot_date,
        type: slot_type_id,
        location: selectedLocation.id,
      })
      return
    }
    setModalType(type)
    setIsModalShown(true)
  }

  const handleSubmit = (evt) => {
    evt.preventDefault()
    setIsModalShown(false)
  }

  const handleClose = () => {
    setIsModalShown(false)
  }

  return (
    <>
      <li
        className={cn({
          [styles.booked_item]: true,
        })}
        style={{ backgroundColor: currentColor }}
        onClick={handleSlotClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setIsTooltipShown(false)}
      >
        <p className={styles.booked_time}>
          {calcTimeWithTimeZoneShift(start_at, timeZone)} -{' '}
          {calcTimeWithTimeZoneShift(finish_at, timeZone)}
        </p>
        {isTooltipShown && (
          <Tooltip
            text={
              (is_client && 'Занятый слот') ||
              (is_deleted && 'Удаленный слот') ||
              type_name
            }
            isAvailable={!is_deleted && is_accessible}
            isOnline={is_online}
            isSchool={is_school}
            isGroup={group_clients}
            isLink={zoom_url}
          />
        )}
        {isMenuShown && (
          <Menu isDeleted={is_deleted} onClick={handleMenuClick} />
        )}
      </li>
      {isModalShown && (
        <BookedSlotModal
          id={id}
          type={modalType}
          slotType={slot_type_id}
          isComment={is_comment}
          isOnline={is_online}
          isSchool={is_school}
          isGroup={group_clients}
          zoomUrl={zoom_url}
          comment={comment}
          onSubmit={handleSubmit}
          onClose={handleClose}
          slot_date={slot_date}
          employee_id={employee_id}
          slot_id={slot_id}
          types={types}
        />
      )}
    </>
  )
}

BookedSlot.propTypes = {
  id: PropTypes.number.isRequired,
  slot_type_id: PropTypes.number.isRequired,
  start_at: PropTypes.string.isRequired,
  finish_at: PropTypes.string.isRequired,
  is_client: PropTypes.bool.isRequired,
  is_deleted: PropTypes.bool.isRequired,
  type_name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isMenuShown: PropTypes.bool,
  is_comment: PropTypes.bool,
  is_accessible: PropTypes.bool,
  is_online: PropTypes.bool,
  is_school: PropTypes.bool,
  comment: PropTypes.string,
  group_clients: PropTypes.bool,
  slot_booking: PropTypes.bool,
  zoom_url: PropTypes.string,
}

export default observer(BookedSlot)
